const chart_data = locationId => `variety/chart-data/${locationId}/canopy_detection`;

const map = locationId => `variety/map/${locationId}`;

export const varietyEndpoints = { chart_data, map };
